var glslify = require("glslify");
var createShader = require("three-glslify")(THREE);
var createWebGeometry = require("./geometry");

function worldPositionVelocityUpdater(coordinates, fromPolarPosition, toWorldPosition, toVelocity) {
    var newWorldPosition = new THREE.Vector3();
    var newVelocity = new THREE.Vector3();
    coordinates.setVector(toWorldPosition, fromPolarPosition);

    return function() {
        coordinates.setVector(newWorldPosition, fromPolarPosition);
        newVelocity.subVectors(newWorldPosition, toWorldPosition);

        if (newVelocity.lengthSq() > 2500) {
            newVelocity.set(0, 0, 0);
        } else {
            newWorldPosition.lerp(toWorldPosition, 0.5);
            newVelocity.lerp(toVelocity, 0.95);
        }

        toVelocity.copy(newVelocity);
        toWorldPosition.copy(newWorldPosition);
    };
}

function shipPositionUniforms(poem, shader, shipPosition) {
    var shipWorldPosition = new THREE.Vector3();
    var shipWorldVelocity = new THREE.Vector3();

    shader.uniforms.shipPosition = {
        type: "v3",
        value: shipWorldPosition
    };

    shader.uniforms.shipVelocity = {
        type: "v3",
        value: shipWorldVelocity
    };

    shader.uniforms.time = {
        type: "f",
        value: 0
    };

    poem.on("update", worldPositionVelocityUpdater(poem.coordinates, poem.ship.position, shipWorldPosition, shipWorldVelocity));
}

var Web = function(poem, properties) {
    this.poem = poem;
    var shader = createShader(require("glslify/simple-adapter.js")("\n#define GLSLIFY 1\n\nuniform vec3 shipPosition;\nuniform vec3 shipVelocity;\nattribute float time;\nvarying vec4 vColor;\nvoid main() {\n  float shipDistance = max(distance(shipPosition, position), 10.0);\n  vColor = vec4(1.0, 0.0, 0.0, 1.0) * 5.0 * length(shipVelocity) / shipDistance;\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position - shipVelocity * 50.0 / (shipDistance * 0.3), 1.0);\n}", "\n#define GLSLIFY 1\n\nvarying vec4 vColor;\nvoid main() {\n  gl_FragColor = vec4(0.2, 0.3, 0.3, 0.1) + vColor;\n}", [{"name":"shipPosition","type":"vec3"},{"name":"shipVelocity","type":"vec3"}], [{"name":"time","type":"float"}]));
    shipPositionUniforms(poem, shader, poem.ship.position);
    var material = new THREE.ShaderMaterial(shader);
    var geometry = createWebGeometry(64, 12, poem.r, poem.height);
    var mesh = new THREE.Mesh(geometry, material);
    material.wireframe = true;
    material.transparent = true;
    poem.scene.add(mesh);
};

module.exports = Web;